import './App.css';
import MainPage from "./pages";

function App() {
  return (
    <div className="App">
      <MainPage/>
    </div>
  );
};

export default App;
